import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_TOTAL_ACCURACY_REQUEST,
  FETCH_TOTAL_ACCURACY_SUCCESS,
  FETCH_TOTAL_ACCURACY_ERROR,
  CLEAR_TOTAL_ACCURACY,
  CANCEL_TOTAL_ACCURACY,
} from 'actionTypes'

/*
 * REQUEST TOTAL_ACCURACYS
 */
export const fetchTotalAccuracy =
  (token, filters, errorCallback) => (dispatch) => {
    dispatch(fetchTotalAccuracyRequest())

    return new Api(token, dispatch)
      .post(API_URL.TOTAL_ACCURACY_FIND, filters)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pages))
        dispatch(fetchTotalAccuracySuccess(response.data))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        errorCallback &&
          errorCallback(error && error.message && error.message.dsMessage)
        dispatch(fetchTotalAccuracyError(error))
        dispatch(hideSpinner())
      })
  }

export const  fetchTotalAccuracyCanceled = () => ({
  type: CANCEL_TOTAL_ACCURACY
})

export const fetchTotalAccuracyReactive = (dsToken, filters, signalController) => (dispatch) => {

  const onClose = () => dispatch(hideSpinner())
  const onError = (error) => {
    dispatch(fetchTotalAccuracyError(error))
    onClose()
  }
  const onMessage = (response) => {
    dispatch(getPages(response.data.pages))
    dispatch(fetchTotalAccuracySuccess(response.data))
    onClose()
  }
  const abort = () => {
    signalController.abort()
    dispatch(fetchTotalAccuracyCanceled())
  }

  dispatch(fetchTotalAccuracyRequest())
  dispatch(showSpinner("", true, abort))
  return new Api(dsToken, dispatch)
  .eventSourceStream(API_URL.TOTAL_ACCURACY_FIND_V2, filters, null, signalController, onMessage, onClose, onError)
  .catch((error) => {
    dispatch(fetchTotalAccuracyError(error))
    dispatch(hideSpinner())
  })

}

export const fetchTotalAccuracyRequest = () => ({
  type: FETCH_TOTAL_ACCURACY_REQUEST,
})

export const fetchTotalAccuracySuccess = (data) => ({
  type: FETCH_TOTAL_ACCURACY_SUCCESS,
  payload: data,
})

export const fetchTotalAccuracyError = (error) => ({
  type: FETCH_TOTAL_ACCURACY_ERROR,
  payload: error,
})

export const clearTotalAccuracy = () => ({
  type: CLEAR_TOTAL_ACCURACY,
})
